<template>
  <div class="py-4 px-8" style="display: flex; align-items: center; justify-content: space-between">
    <span style="font-size: 13px; font-weight: 500">Quản lý nhóm giảng viên</span>
    <div>
      <el-button
        type="text"
        style="
          background: #3699ff;
          color: white;
          padding: 10px 20px;
          margin-right: 10px;
        "
        @click="isImport = true"
      >
      <i class="flaticon-upload" style="color: white !important"></i>
        Import
      </el-button>

    <el-button type="text" style="background: #1BC5BD; color: white; padding: 10px 20px" @click="isAdd = true">Thêm mới</el-button>
    </div>

    <el-dialog
        v-if="isAdd"
        :visible.sync="isAdd"
        title="Thêm mới nhóm giảng viên"
        width="30%" :show-close="false"
        :before-close="handleClose"
    >
      <hr style="margin-top: -20px; margin-bottom: 20px"/>
      <DialogAddGroupTeacher @closeDialog="isAdd = false" @getListGroupTeacher="getListGroupTeacher"/>
    </el-dialog>

    <el-dialog
      v-if="isImport"
      :visible.sync="isImport"
      title="Import nhóm giảng viên mới"
      width="55%"
      :show-close="true"
      :before-close="handleImportClose"
    >
      <hr style="margin-top: -20px; margin-bottom: 20px" />
      <DialogImportGroupTeacher
        @closeDialog="isImport = false"
        @getListGroupTeacher="getListGroupTeacher"
      />
    </el-dialog>
  </div>
</template>

<script>
import DialogAddGroupTeacher from "./DialogAddGroupTeacher.vue";
import DialogImportGroupTeacher from "./DialogImportGroupTeacher.vue"; 
export default {
  name: "HeaderManageGroupTeacher",
  components: {
    DialogAddGroupTeacher,
    DialogImportGroupTeacher, 
  },
  data() {
    return {
      isAdd: false,
      isImport: false, 
    };
  },
  methods: {
    handleClose() {
      this.isAdd = false;
    },
    handleImportClose() {
      this.isImport = false;
    },
    getListGroupTeacher() {
      this.$emit('getListGroupTeacher')
    }
  }
}
</script>

<style scoped>

</style>